// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b-example-divider {
  height: 3rem;
  background-color: rgba(0, 0, 0, .1);
  border: solid rgba(0, 0, 0, .15);
  border-width: 1px 0;
  box-shadow: inset 0 .5em 1.5em rgba(0, 0, 0, .1), inset 0 .125em .5em rgba(0, 0, 0, .15);
}

.bi {
  vertical-align: -.125em;
  fill: currentColor;
}

.feature-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  margin-bottom: 1rem;
  font-size: 2rem;
  color: #fff;
  border-radius: .75rem;
}

.icon-link {
  display: inline-flex;
  align-items: center;
}
.icon-link > .bi {
  margin-top: .125rem;
  margin-left: .125rem;
  transition: transform .25s ease-in-out;
  fill: currentColor;
}
.icon-link:hover > .bi {
  transform: translate(.25rem);
}

.icon-square {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  font-size: 1.5rem;
  border-radius: .75rem;
}

.rounded-4 { border-radius: .5rem; }
.rounded-5 { border-radius: 1rem; }

.text-shadow-1 { text-shadow: 0 .125rem .25rem rgba(0, 0, 0, .25); }
.text-shadow-2 { text-shadow: 0 .25rem .5rem rgba(0, 0, 0, .25); }
.text-shadow-3 { text-shadow: 0 .5rem 1.5rem rgba(0, 0, 0, .25); }

.card-cover {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
`, "",{"version":3,"sources":["webpack://./node_modules/bootstrap/dist/css/features.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;EAChC,mBAAmB;EACnB,wFAAwF;AAC1F;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,aAAa,oBAAoB,EAAE;AACnC,aAAa,mBAAmB,EAAE;;AAElC,iBAAiB,gDAAgD,EAAE;AACnE,iBAAiB,8CAA8C,EAAE;AACjE,iBAAiB,8CAA8C,EAAE;;AAEjE;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,sBAAsB;AACxB","sourcesContent":[".b-example-divider {\n  height: 3rem;\n  background-color: rgba(0, 0, 0, .1);\n  border: solid rgba(0, 0, 0, .15);\n  border-width: 1px 0;\n  box-shadow: inset 0 .5em 1.5em rgba(0, 0, 0, .1), inset 0 .125em .5em rgba(0, 0, 0, .15);\n}\n\n.bi {\n  vertical-align: -.125em;\n  fill: currentColor;\n}\n\n.feature-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 4rem;\n  height: 4rem;\n  margin-bottom: 1rem;\n  font-size: 2rem;\n  color: #fff;\n  border-radius: .75rem;\n}\n\n.icon-link {\n  display: inline-flex;\n  align-items: center;\n}\n.icon-link > .bi {\n  margin-top: .125rem;\n  margin-left: .125rem;\n  transition: transform .25s ease-in-out;\n  fill: currentColor;\n}\n.icon-link:hover > .bi {\n  transform: translate(.25rem);\n}\n\n.icon-square {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 3rem;\n  height: 3rem;\n  font-size: 1.5rem;\n  border-radius: .75rem;\n}\n\n.rounded-4 { border-radius: .5rem; }\n.rounded-5 { border-radius: 1rem; }\n\n.text-shadow-1 { text-shadow: 0 .125rem .25rem rgba(0, 0, 0, .25); }\n.text-shadow-2 { text-shadow: 0 .25rem .5rem rgba(0, 0, 0, .25); }\n.text-shadow-3 { text-shadow: 0 .5rem 1.5rem rgba(0, 0, 0, .25); }\n\n.card-cover {\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
